import React from 'react';
import UserRoutes from './UserRoutes';

declare global {
  interface Window {
    analytics: any;
  }
}
window.analytics = window.analytics || {};

const AuthorizedRoutes = () => {
  return <UserRoutes />;
};

export default AuthorizedRoutes;
